import { put, take, select, call } from "redux-saga/effects";
import { FeedConstants } from "../constants/feed.constants";
import { feedFailure, feedSuccess } from "../actions/feed.actions";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import { graphQLPostContents } from "./query.helper";

export function* requestFeed() {
    while (true) {
        const action = yield take(FeedConstants.FEED_REQUEST);
        try {
            const {
                languages,
                userId
            } = yield select(({ userSettings: { languages, id: userId } }) => {
                return { languages, userId };
            });
            if (languages.count() > 0) {
                const results = yield call(fetchPosts, action);
                yield put(feedSuccess(Object.assign({}, results, { userId })));
            }
        } catch (e) {
            yield call(handleFailure, e, feedFailure);
        }
    }
}

function* fetchPosts({ payload: { after } }) {
    const {
        languages,
        sort
    } = yield select(({ userSettings: { languages }, feed: { sort } }) => {
        return { languages, sort };
    });

    const postLanguages = languages
        .filter(l => !l.isLearning)
        .map(l => l.language);

    after = after || "";

    const query = `{
        posts(
            languages: ${JSON.stringify(postLanguages.toJS())}
            sort: ${sort}
            after: ${JSON.stringify(after)}
            first: 10
        ) ${graphQLPostContents(false)}
    }`;
    return yield doGraphQLQuery(query);
}



// WEBPACK FOOTER //
// ./src/sagas/feed.saga.js